import { IconProps } from 'interfaces';
import COLOR from 'constants/color';

const Apps = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-4',
  styles
}: IconProps) => {
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
    >
      <rect
        x='3'
        y='3'
        width='6'
        height='6'
        rx='1'
        stroke={fill}
        strokeWidth='2'
        fill='none'
      />
      <rect
        x='15'
        y='3'
        width='6'
        height='6'
        rx='1'
        stroke={fill}
        strokeWidth='2'
        fill='none'
      />
      <rect
        x='3'
        y='15'
        width='6'
        height='6'
        rx='1'
        stroke={fill}
        strokeWidth='2'
        fill='none'
      />
      <rect
        x='15'
        y='15'
        width='6'
        height='6'
        rx='1'
        stroke={fill}
        strokeWidth='2'
        fill='none'
      />
    </svg>
  );
};

export default Apps;
